import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Typography } from 'antd';
import FlashCard from 'components/FlashCard';
import { GtvIcon, PartnersCommissionIcon, LoginIcon, SignUpIcon } from 'utils/icons';
import dayjs from 'dayjs';
import loginCard from 'assets/images/login_card.webp';
import signupCard from 'assets/images/signup_card.webp';

function CombineCard({ gtv, login, isKycComplte }) {
  return (
    <div>
      {isKycComplte && Object.entries(gtv).length > 0 ? (
        <Row gutter={[30, 30]}>
          <Col span={24}>
            <FlashCard
              icon={<GtvIcon style={{ fontSize: '30px', minWidth: '100%', width: '100%' }} />}
              title={gtv?.summary[0].title}
              data={gtv?.summary[0].data}
            />
          </Col>
          <Col span={24}>
            <FlashCard
              icon={
                <PartnersCommissionIcon
                  style={{ fontSize: '30px', minWidth: '100%', width: '100%' }}
                />
              }
              title={gtv?.summary[1].title}
              data={gtv?.summary[1].data}
            />
          </Col>
        </Row>
      ) : (
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Row
              style={{
                background: `url(${signupCard}) no-repeat`,
                backgroundSize: 'cover',
                boxShadow: '0px 1px 6px #00000014',
                borderRadius: '10px',
                padding: '24px'
              }}
            >
              <Col span={4} style={{ marginTop: '4%' }}>
                <SignUpIcon style={{ fontSize: '50px' }} />
              </Col>
              <Col span={20} style={{ paddingLeft: '2%', marginTop: '-2%' }}>
                <Typography.Title level={5} style={{ color: '#8F93A8' }}>
                  Sign Up Date
                </Typography.Title>
                <Typography.Text style={{ color: '#2A2A2A', fontWeight: 'bold' }}>
                  {login?.signup_date != null
                    ? dayjs(login?.signup_date).format('DD MMM, YYYY HH:mm A')
                    : 'NA'}
                </Typography.Text>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row
              style={{
                background: `url(${loginCard})`,
                backgroundSize: 'cover',
                boxShadow: '0px 1px 6px #00000014',
                borderRadius: '10px',
                padding: '24px'
              }}
            >
              <Col span={4} style={{ marginTop: '4%' }}>
                <LoginIcon style={{ fontSize: '50px', marginTop: '4%' }} />
              </Col>
              <Col span={20} style={{ paddingLeft: '2%', marginTop: '-2%' }}>
                <Typography.Title level={5} style={{ color: '#8F93A8' }}>
                  Last Login Date
                </Typography.Title>
                <Typography.Text style={{ color: '#2A2A2A', fontWeight: 'bold' }}>
                  {login?.last_login_date != null
                    ? dayjs(login?.last_login_date).format('DD MMM, YYYY HH:mm A')
                    : 'Not Logged In'}
                </Typography.Text>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
}
CombineCard.propTypes = {
  gtv: PropTypes.instanceOf(Object),
  login: PropTypes.instanceOf(Object),
  isKycComplte: PropTypes.bool.isRequired
};

CombineCard.defaultProps = {
  gtv: {},
  login: {}
};

export default CombineCard;
